import AddHomeIcon from '@mui/icons-material/AddHome';
import AddHospital from '../pages/Hospitals/AddHospital';
import AddNurses from '../pages/Nurses/AddNurses';
import AllTest from '../pages/TestList/AllTest';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import Dashboard from '../pages/Dashboard/Dashboard';
import Feedback from '../pages/Feedback/Feedback';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import HospitalList from '../pages/Hospitals/HospitalList';
import HospitalReferredTest from '../pages/TestList/HospitalReferredTest';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import MasksIcon from '@mui/icons-material/Masks';
import NurseDetails from '../pages/NurseDetails/NurseDetails';
import NurseDetailsView from '../pages/NurseDetails/NurseDetailsView';
import NursesList from '../pages/Nurses/NursesList';
import PateintDetailUpdate from '../pages/PatientList/PateintDetailUpdate';
import PatientList from '../pages/PatientList/PatientList';
import PatientReferredList from '../pages/TestList/PatientReferredList';
import RecordForm from '../pages/PatientList/RecordForm';
import RejectedList from '../pages/TestList/RejectedList';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import UserDetails from '../pages/PatientList/UserDetails';
import ViewHospital from '../pages/Hospitals/viewHospital';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewNurse from '../pages/Nurses/ViewNurse';

const PATH = {
    HOME: '/',
    MENU: [
        {
            name: 'Home',
            path: '/',
            icon: AddHomeIcon,
            element: <Dashboard/>,
        },
        {
            name: 'Referral Facilities',
            path: '/hospital-list',
            icon: LocalHospitalIcon,
            element: <HospitalList/>,
            children: [
                {
                    name: 'Add Hospital',
                    path: '/hospital-list/add',
                    element: <AddHospital/>,
                },
                {
                    name: 'Add Hospital',
                    path: '/hospital-list/view',
                    element: <ViewHospital/>,
                },
            ]
        },
        {
            name: 'Nurses',
            path: '/nurses-list',
            icon:  MasksIcon,
            element: <NursesList/>,
            children:[
                {
                    name: 'Add Nurse',
                    path: '/nurses-list/add',
                    element: <AddNurses/>,
                },
                {
                    name: 'Add Hospital',
                    path: '/nurses-list/view',
                    element: <ViewNurse/>,
                },
            ]
        },
        {
            name: 'Patients',
            path: '/patient-list',
            icon:  FormatListNumberedIcon,
            element: <PatientList/>,
            children:[
                {
                    name: 'Patient Details',
                    path: '/patient-list/users/:patient_code',
                    element: <UserDetails/>,
                },
                {
                    name: 'Patient Details Update',
                    path: '/patient-list/add',
                    element: <PateintDetailUpdate/>,
                },
                {
                    name: 'Add Hospital',
                    path: '/patient-list/users/record_detail_form/:user_form_id',
                    element: <RecordForm/>,
                },
            ]
        },
        {
            name: 'Test List',
            path: '/all-test-list',
            icon: ViewListIcon,
            element: <AllTest/>,
        },
        {
            name: 'Rejected Tests',
            path: '/rejected-test-list',
            icon: ThumbDownIcon,
            element: <RejectedList/>,
        },
        {
            name: 'Referred Tests',
            path: '/hospital-referred-test-list',
            icon: AssignmentIndIcon,
            element: <HospitalReferredTest/>,
            children: [
                {
                    name: 'Patient Referred List',
                    path: '/hospital-referred-test-list/view/:hospital_id',
                    element: <PatientReferredList/>,
                },
            ]
        },

        {
            name: 'Feedback',
            path: '/feedback',
            icon: ThumbUpAltIcon,
            element: <Feedback/>,
        },
        {
            name: 'Nurses Performance',
            path: '/master_admin_dashbord/nurse_detail_data',
            icon: MasksIcon,
            element: <NurseDetails/>,
            children: [
                {
                    name: 'View Nurse Details',
                    path: '/master_admin_dashbord/nurse_detail_data/view',
                    element: <NurseDetailsView/>,
                }
            ]
        },
     
        
    ],
    LOGIN: '/auth/login',
}

export default PATH;